import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import image1 from "../../assets/Awardphoto1.png";
import image2 from "../../assets/Awardphoto2.png";
import image3 from "../../assets/Awardphoto3.png";
import image4 from "../../assets/Awardphoto4.png";
import image5 from "../../assets/Awardphoto5.png";

const AwardPhotos = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);
  return (
    <div className="container mx-auto  pt-8">
      <div className="flex flex-col md:flex-row gap-4 mb-4">
        <div
          className="w-full md:w-1/2"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="h-full">
            <img
              src={image3}
              alt="Award ceremony"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </div>

        <div
          className="w-full md:w-1/2 flex flex-col gap-4"
          data-aos="fade-left"
          data-aos-delay="200"
        >
          <div className="h-1/2" data-aos="fade-left" data-aos-delay="300">
            <img
              src={image2}
              alt="Award ceremony"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          <div className="h-1/2">
            <img
              src={image1}
              alt="Award ceremony"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-4">
        <div
          className="w-full md:w-1/2"
          data-aos="fade-right"
          data-aos-delay="400"
        >
          <div className="h-full">
            <img
              src={image4}
              alt="Industrial equipment"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </div>
        <div
          className="w-full md:w-1/2"
          data-aos="fade-left"
          data-aos-delay="500"
        >
          <div className="h-full">
            <img
              src={image5}
              alt="Group photo"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AwardPhotos;
